import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgHome extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 261.13 265.44" height={size}>
                <polygon points="0 209.72 56.15 209.72 28.08 184.87 0 209.72" fill={color} />
                <path
                    d="M16.72,231.72v55.35h56.2V231.72Zm24.4,33.42H32.74v-8.38h8.38Zm0-14.9H32.74v-8.38h8.38Zm15.79,14.9H48.53v-8.38h8.38Zm0-14.9H48.53v-8.38h8.38Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <rect x="43.42" y="188.66" width="6.31" height="20.76" fill={color} />
                <path
                    d="M93,234.84c0,6.75-3,12.22-6.61,12.22s-6.6-5.47-6.6-12.22,2.95-12.22,6.6-12.22S93,228.09,93,234.84Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path
                    d="M84.55,243.93c0,4.64-2.89,8.39-6.45,8.39s-6.46-3.75-6.46-8.39,2.89-8.39,6.46-8.39S84.55,239.3,84.55,243.93Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path
                    d="M96.47,245.32c0,3.87-2.38,7-5.31,7s-5.32-3.13-5.32-7,2.38-7,5.32-7S96.47,241.46,96.47,245.32Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path
                    d="M90.51,259.31c0,5.19-3.11,9.4-7,9.4s-7-4.21-7-9.4,3.11-9.4,7-9.4S90.51,254.12,90.51,259.31Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path d="M89,251.25a5.45,5.45,0,1,1-5.43-5.11A5.27,5.27,0,0,1,89,251.25Z" transform="translate(-16.72 -22)" fill={color} />
                <path
                    d="M80,254.74c0,2.55-1.54,4.62-3.43,4.62s-3.43-2.07-3.43-4.62,1.54-4.63,3.43-4.63S80,252.18,80,254.74Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path
                    d="M96.57,253.45c0,4-2.42,7.31-5.41,7.31s-5.42-3.28-5.42-7.31,2.43-7.31,5.42-7.31S96.57,249.42,96.57,253.45Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <path
                    d="M83.21,235.55c0,2.55-1.53,4.62-3.42,4.62s-3.43-2.07-3.43-4.62,1.53-4.63,3.43-4.63S83.21,233,83.21,235.55Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <ellipse cx="75.68" cy="216.32" rx="3.43" ry="4.63" fill={color} />
                <path
                    d="M92.85,260.76c0,2.55-1.54,4.62-3.43,4.62S86,263.31,86,260.76s1.54-4.63,3.43-4.63S92.85,258.2,92.85,260.76Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <rect x="67.23" y="234.13" width="2.04" height="31.15" fill={color} />
                <path
                    d="M162.49,205.74l-35.21-31.17L92.07,205.74h0v81.08h70.48V205.74Zm-40.05,59.83h-8.38v-8.38h8.38Zm0-14.91h-8.38v-8.38h8.38Zm0-14.91h-8.38v-8.38h8.38Zm15.78,29.82h-8.38v-8.38h8.38Zm0-14.91h-8.38v-8.38h8.38Zm0-14.91h-8.38v-8.38h8.38Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
                <rect x="155.08" width="83.08" height="31.45" fill={color} />
                <path
                    d="M276.34,53.55H148.84V287.44h129Zm-97.7,159.91h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83ZM191.5,213.46h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83Zm18.83,131.53H203.5v-6.83h6.83Zm0-12.15H203.5v-6.83h6.83Zm0-17.69H203.5v-6.84h6.83Zm0-12.16H203.5v-6.83h6.83Zm0-17.69H203.5v-6.83h6.83Zm0-12.15H203.5v-6.83h6.83Zm0-17.69H203.5V117.1h6.83Zm0-12.16H203.5V105h6.83Zm0-17.69H203.5V87.25h6.83Zm0-12.15H203.5V75.1h6.83ZM223.2,213.46h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83ZM242,213.46h-6.83v-6.83H242Zm0-12.15h-6.83v-6.83H242Zm0-17.69h-6.83v-6.84H242Zm0-12.16h-6.83v-6.83H242Zm0-17.69h-6.83v-6.83H242Zm0-12.15h-6.83v-6.83H242Zm0-17.69h-6.83V117.1H242Zm0-12.16h-6.83V105H242Zm0-17.69h-6.83V87.25H242Zm0-12.15h-6.83V75.1H242Zm12.87,131.53h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.84h6.83Zm0-12.16h-6.83v-6.83h6.83Zm0-17.69h-6.83v-6.83h6.83Zm0-12.15h-6.83v-6.83h6.83Zm0-17.69h-6.83V117.1h6.83Zm0-12.16h-6.83V105h6.83Zm0-17.69h-6.83V87.25h6.83Zm0-12.15h-6.83V75.1h6.83Z"
                    transform="translate(-16.72 -22)"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgHome);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgManagement.js